import { useRef } from "react"
import { CaretRounded } from "@/common/icons/caret"
import Button from "@/common/button/button"
import Magnifier from "@/common/icons/magnifier"
import { useArchiveContext } from "@/lib/contexts/archiveContext"
import { trackSearch } from "@/lib/helpers/tagManager"
import Block from "@/components/wrappers/block"
import styles from "./personnel-header.module.css"
import Breadcrumbs from "@/components/base/breadcrumbs/breadcrumbs"

export default function PersonnelHeader({ block }) {
  const store = useArchiveContext()
  const { heading, search, description } = block.attrs
  const stringInput = useRef()

  const doSearch = () => {
    store.setPhrase(stringInput.current.value)
    trackSearch(stringInput.current.value, "personnel")
  }

  const doSelect = (e) => {
    store.setSelected([e.target.value])
  }

  const checkSubmit = (e) => {
    if (e.code === "Enter") {
      doSearch()
    }
  }

  const options = search.options.map((item, key) => {
    return (
      <option key={key} value={item.slug}>
        {item.label}
      </option>
    )
  })

  return (
    <Block
      block={block}
      className={styles.wrapper}
      width="bleed"
      noStyling="true">
      <Breadcrumbs gap="none" width="full" type="large" />
      <div className={styles.content}>
        <h1>{heading}</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
      <div className={styles.form}>
        <div className="input-wrapper">
          <div className="input">
            <Magnifier className="w-5 mr-4 fill-current stroke-current" />
            <input
              onKeyUp={checkSubmit}
              ref={stringInput}
              type="text"
              placeholder={search.placeholder}
            />
          </div>
        </div>
        {search.options.length > 0 && (
          <div className="select-wrapper">
            <div className="select">
              <select value={store.selected[0]} onChange={doSelect}>
                {options}
              </select>
              <CaretRounded className="absolute top-0 right-0 mt-6 mr-4 pointer-events-none" />
            </div>
          </div>
        )}
        <div className="button-wrapper">
          <Button
            theme="lime"
            onClick={() => {
              doSearch()
            }}>
            Sök
          </Button>
        </div>
      </div>
    </Block>
  )
}
